import { BrandProp } from "@mojo/types";
import { useMemo } from "react";

export const Logo = ({ brand }: BrandProp) => {
  const { logo, width } = useMemo(() => {
    switch (brand) {
      case "Uswitch":
        return {
          logo: "https://hosted-assets.mojomortgages.com/images/partners/uswitch-dark.svg",
          width: 130,
        };
      case "Money":
        return {
          logo: "https://hosted-assets.mojomortgages.com/images/partners/money-dark.svg",
          width: 130,
        };
      case "Mojo":
      default:
        return {
          logo: "https://hosted-assets.mojomortgages.com/images/mojo/mojo-logo.svg",
          width: 130,
        };
    }
  }, [brand]);

  return <img src={logo} width={width} />;
};
